export default {
    baseStyle: {
        color: 'textColor',
        _hover: {
            textDecoration: 'none !important',
            _disabled: {color: 'gray.900'}
        }
    },
    variants: {
        underline: {
            textDecoration: 'underline !important',
            textUnderlineOffset: '2px',
            textUnderlinePosition: 'from-font',
            textDecorationThickness: '1px !important'
        }
    }
}
